import { ConstrainedListSearchFilterDTO } from "./ConstrainedListSearchFilter";
import { DateRangeSearchFilterDTO } from "./DateRangeSearchFilter";
import { LocationFilterDTO } from "./LocationSearchFilter";
import { MultiTextFilterDTO } from "./MultiTextSearchFilter";
import { NestedConstrainedListSearchFilterDTO } from "./NestedConstrainedListSearchFilter";
import { NumberSearchFilterDTO } from "./NumberSearchFilter";
import { NumberRangeSearchFilterDTO } from "./NumberRangeSearchFilter";
import { TextSearchFilterDTO } from "./TextSearchFilter";
import { RegionSearchFilterDTO } from "./RegionSearchFilter";

export type CompoundFilterId =
  | "planning-applications-id"
  | "amenities-filter"
  | "owner-portfolio-id"
  | "power-id"
  | "traffic-count-id"
  | "adopted-roads-id";

export enum CompoundFilterMust {
  MATCH_ALL = "MATCH_ALL",
  MATCH_ANY = "MATCH_ANY",
  MATCH_NONE = "MATCH_NONE",
}

export type CompoundFilterMustDTO = keyof typeof CompoundFilterMust;

// export interface ICompoundFilter {
//   id: CompoundFilterId;
//   filters: Array<
//     | IConstrainedListSearchFilter
//     | IDateRangeSearchFilter
//     | ILocationFilter
//     | IMultiTextFilter
//     | INestedConstrainedListSearchFilter
//     | INumberRangeSearchFilter
//     | ITextSearchFilter
//     | INumberSearchFilter
//   >;
//   must: CompoundFilterMust;
//   type: "compound";
// }

export interface CompoundFilterDTO {
  id: CompoundFilterId;
  filters: Array<
    | ConstrainedListSearchFilterDTO
    | DateRangeSearchFilterDTO
    | LocationFilterDTO
    | MultiTextFilterDTO
    | NestedConstrainedListSearchFilterDTO
    | NumberRangeSearchFilterDTO
    | TextSearchFilterDTO
    | NumberSearchFilterDTO
    | RegionSearchFilterDTO
  >;
  must: CompoundFilterMustDTO;
  type: "compound";
}
